import { createReducer } from '@reduxjs/toolkit';

import {
  setAllUsersData,
  setAllUsersDataByID,
} from '../../Actions/AllUsersActions';

export const defaultAllUsersState = [];

const allUsers = createReducer(defaultAllUsersState, {
  [setAllUsersData]: (state, action) => {
    return [...action.payload];
  },
  [setAllUsersDataByID]: (state, action) => {
    return state.map(user => {
      if (user._id === action.payload._id) {
        user = action.payload;
      }
      return user;
    });
  },
});

export default allUsers;
